
const types = {

    HTTP_PENDING_IMPORTER: 'HTTP_PENDING_IMPORTER',
    HTTP_ERROR_IMPORTER: 'HTTP_ERROR_IMPORTER',
    HTTP_SUCCESS_IMPORTER: 'HTTP_SUCCESS_IMPORTER',

 

 
}
const actions = {
    //HTTP
    startHTTPRequest: () => ({
        type: types.HTTP_PENDING_IMPORTER,
    }),
    stopHTTPRequestError: (error) => ({
        type: types.HTTP_ERROR_IMPORTER,
        error: error
    }),
    stopRequestSuccess: (payload) => ({
        type: types.HTTP_SUCCESS_IMPORTER,
        payload: payload
    }),


   
}



export { types, actions };
